import { IMintRes } from "@novel/shared/interfaces/TokenCollectionClaim";
import { retryWithBackoff } from "@novel/shared/utils/retryWithBackoff";
import { typedFrontendGalleryApi } from "@customer-gallery/utils/typedFrontendGalleryApi";

export interface MintClaimCentralizedArgs {
    orderId: string;
    claimQuantity: number;
    cryptoAddress: string;
    collectionContractAddress: string;
}

export async function mintTokensForClaimCentralizedApiCall(
    mintClaimArgs: MintClaimCentralizedArgs,
): Promise<IMintRes> {
    return retryWithBackoff(() => _mintTokensForClaimApiCall(mintClaimArgs));
}

async function _mintTokensForClaimApiCall({
    orderId,
    claimQuantity,
    cryptoAddress,
    collectionContractAddress,
}: MintClaimCentralizedArgs): Promise<IMintRes> {
    const res = await typedFrontendGalleryApi.postReq("/api/customer/:cryptoAddress/mint", {
        params: {
            cryptoAddress,
        },
        reqBody: {
            orderId,
            quantity: claimQuantity,
            collectionContractAddress,
        },
    });

    if (res.type === "error") {
        throw res.error;
    }

    return res.body;
}
